export default __webpack_public_path__ + "static/media/entry.fd6c9d8a.jpg";